<header class="py-12 px-16 py-24-768 px-48-768 dashboardHeader border-bottom-rgbaGrey500">
  <div
    class="logo-container d-flex align-items-center justify-content-md-center justify-content-between gap-16-768 relative flex-grow-1">
    <a href="{{cxDomain}}"><img src="assets/images/idp-ielts-cobrand-rgb.svg" class="idp-logo" alt="IDP logo" /></a>
    <div class="profile">
      <button class="profile-name d-flex align-items-center justify-content-around background-charcoalGrey500 circle"
        (click)="profileDropdown()" (keyup)="profileDropdown()"><span class="heading6 heading6-768 txt-white font-semibold">{{userName?.charAt(0)?.toUpperCase()}}</span></button>
      </div>
    </div>
    @if (showProfileDropdown) {
      <div
        class="profile-dropdown border-rgbaGrey500 flex-column background-white py-16 gap-12 py-20-768 gap-16-768 round-4 round-4-768 shadow-small z-4 d-flex">
        <div class="profile d-flex flex-column gap-16 gap-16-768">
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768" (click)="openProfilePage()" (keyup)="openProfilePage()">
            <img src="assets/images/person-circle-outline.svg" alt="profile" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">My profile</span>
          </button>
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768" (click)="openAccountSettings()">
            <img src="assets/images/settings.svg" alt="settings" width="24" height="24" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">Account settings</span>
          </button>
        </div>
        <div class="divider background-rgbaGrey500">
        </div>
        <div class="logout">
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768 w-100" (click)="signOut()" (keyup)="signOut()">
            <img src="assets/images/exit-outline.svg" alt="exit" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">Log out</span>
          </button>
        </div>
      </div>
    }
  </header>
  <section class="dashboard">
    <div class="dashboard__body d-flex flex-column background-universalSetSnow">
      <div class="dashboard__content d-flex flex-column gap-32 gap-64-768 py-32 py-64-768 mx-auto">
        <div class="profile-and-cards d-flex flex-column gap-16 gap-24-768 p-md-0 relative">
          <div class="d-flex align-items-center justify-content-between">
            <div class="profile px-24 padding-0-768">
              <h2 class="profile__name heading2 heading2-768 text-black font-bold">Hello {{userName}}</h2>
              <p class="prfile__email paragraph-large-768 paragraph-Medium txt-gray-600 font-open">{{userEmail}}
              </p>
            </div>
            <button class="py-12-768 py-12 px-12-768 background-red500 round-100 txt-white paragraph-extra-Medium-768 paragraph-extra-Medium font-semibold d-none d-md-flex justify-content-center dashboard_booknow" (click)="goToBooking()">Book now</button>
            <div class="book_now_mobile d-flex d-md-none fixed" (click)="goToBooking()">
              <img src="assets/images/book-now-mob.svg" alt="book now">
            </div>
          </div>
          <div class="custom-card-wrapper relative" [ngClass]="{ 'drop-open': openDropDown }">

            <drag-scroll
              #scrollContainerRef
              class="relative customcard-scroll"
              (reachesLeftBound)="leftBoundStat($event)"
              (reachesRightBound)="rightBoundStat($event)"
              [snap-duration]="200"
              scroll-x="true"
              [drag-scroll-disabled]="false"
              [snap-disabled]="true"
              >
              <section class="customcards d-flex align-items-center gap-12 gap-24-768 relative"
                drag-scroll-item>
                @for (card of scrollableCards; track card) {
                  <button
                    class="customcard d-flex flex-column p-20 gap-20 gap-20-768 p-24-768 round-8 shadow-xsmall relative align-self-stretch"
                    drag-scroll-item
                [ngClass]="{
                  'order-1': card.type === 'unpaid',
                  'order-4': card.type === 'offlinePending',
                  'order-5': card.type === 'offlineConfirmed',
                  'order-3': card.type === 'completed',
                  'order-2': card.type === 'result',
                  'background-white': card.type !== 'offlinePending',
                  'border-rgbaGrey500': card.type !== 'offlinePending'
                }"
                type="button"
              >
              <ng-container>
                <ng-container>
                    @if (card.bookingDetails?.paymentMethod === 'OFFLINE' && card.bookingDetails?.paymentStatus === 'IN_PROGRESS' && !card.bookingDetails?.offlineExpiryUnavailable) {
                      <app-expiry-badge
                        variant="banner"
                        [expiryDate]="card.bookingDetails?.offlineExpiryDate"
                        [timeZone]="card.bookingDetails?.testLocation?.testLocationTimeZone"
                        [loading]="card.bookingDetails?.offlineExpiryLoading"
                        expiredLabel="Offline Payment required"
                        dueLabel="Due">
                      </app-expiry-badge>
                    }
                    <div class="d-flex flex-column gap-12 gap-16-768 flex-grow-1">
                      <div class="customcard__heading d-flex flex-column">
                        <h3 class="heading5 font-semibold txt-burgundyRed500 heading5-768">{{card?.nbaPod?.title}}</h3>
                        @if (card?.nbaPod?.shortDescription) {
                          <p class="paragraph-small font-open txt-charcoalGrey500 paragraph-small-768 customcardPara mt-1">{{card?.nbaPod?.shortDescription}}</p>
                        }
                        @if (card?.bookingDetails?.receiptNumber && card?.bookingDetails?.showReceiptNumber) {
                          <p class="paragraph-small font-open txt-charcoalGrey500 paragraph-small-768 customcardPara mt-1">
                            Booking Reference ID: {{ card?.bookingDetails?.receiptNumber }}
                          </p>
                        }
                      </div>
                      <div class="customcard__content d-flex flex-column background-stoneGrey200 round-8 gap-8 p-16 p-16-768 gap-8-768">
                        <h4 class="heading5 heading6-768 text-black font-semibold">{{card?.bookingDetails?.bookableProduct }}</h4>
                        <div class="d-flex flex-column flex-md-row flex-wrap gap-8 gap-16-768 test-details">
                          <p class="d-flex align-items-start txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                            <img src="/assets/images/calender-gary.svg" alt="calendar icon" />{{ getSkillFormattedDate(card?.bookingDetails?.lrwStartDateTimeUtc,card?.bookingDetails?.speakingStartDateTimeUtc, card?.bookingDetails?.testLocation?.testLocationTimeZone) }}
                          </p>
                          <p class="d-flex align-items-start align-items-md-center txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                            <img src="/assets/images/clock-gray.svg" alt="clock icon" />{{ getSkillFormattedTime(card.bookingDetails?.lrwStartDateTimeUtc,card.bookingDetails?.speakingStartDateTimeUtc,card.bookingDetails?.testLocation?.testLocationTimeZone,(card.bookingDetails?.testLocation?.testLocationAddresses?.[0]?.countryCode)||'') }} ({{ getTestSkillLabel(card.bookingDetails?.bookableProduct, card.bookingDetails?.lrwStartDateTimeUtc, card.bookingDetails?.speakingStartDateTimeUtc) }})
                          </p>
                          <p class="d-flex align-items-start txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                            <img [src]="card?.bookingDetails?.imageIcon" alt="on paper icon" />{{ getTestFormat(card?.bookingDetails?.bookingLines) }}
                          </p>
                          @if (card?.bookingDetails?.bookingLines[0]?.testFormat?.toLowerCase() == 'paper-based') {
                            <p class="d-flex align-items-start txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                              <img [src]="getWritingFormatImagePath(card?.bookingDetails?.bookingLines)" alt="on paper icon" >{{ getWritingFormat(card?.bookingDetails?.productName) }}
                            </p>
                          }
                          <p class="d-flex align-items-start txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                            <img src="/assets/images/building-gray.svg" alt="building icon" />{{ card?.bookingDetails?.testLocation?.name }}
                          </p>
                          <p class="d-flex align-items-start txt-black font-open paragraph-small gap-8 paragraph-small-768 gap-8-768">
                            <img src="/assets/images/location-gray.svg" alt="location icon" />{{ getAddressFormat(card?.bookingDetails?.testLocation?.testLocationAddresses) }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="customcard__links d-flex gap-12 gap-20-768 w-100 justify-content-between">
                      <div class="links d-flex align-items-center gap-16 gap-16-768">
                        @if (!isBiometricConsentCard(card)) {
                          <a
                            href=""
                            class="paragraph-small lh-16-0 lh-16-768 paragraph-small-768 txt-charcoalGrey500 text-decoration-underline"
                            (click)="navigateToBooking($event, card, card?.nbaPod?.callToActionCta?.primaryCtaUrl)"
                          >
                            {{card?.nbaPod?.callToActionCta?.primaryCtaLabel}}
                          </a>
                        } @else {
                          <button
                            type="button"
                            class="biometric-consent-link paragraph-small lh-16-0 lh-16-768 paragraph-small-768 txt-charcoalGrey500 text-decoration-underline"
                            (click)="openBiometricConsentOverlay($event, card)"
                            (keyup.enter)="openBiometricConsentOverlay($event, card)"
                          >{{card?.nbaPod?.callToActionCta?.primaryCtaLabel}}</button>
                        }
                        @if (card?.nbaPod?.callToActionCta?.secondaryCtaLabel) {
                          <a
                            tabindex="0"
                            class="paragraph-small lh-16-0 lh-16-768 paragraph-small-768 txt-charcoalGrey500 text-decoration-underline"
                            (click)="secondaryCtaAction($event,card)"
                            (keyup.enter)="secondaryCtaAction($event,card)"
                            role="button"
                          >{{card?.nbaPod?.callToActionCta?.secondaryCtaLabel}}</a>
                        }
                      </div>
                      @if (card?.bookingDetails?.paymentMethod ==='ONLINE'
                        && card?.bookingDetails?.paymentStatus === 'UNPAID'
                        && card?.bookingDetails?.expiryDateTimeSeconds > 0) {
                        <div class="label-button d-flex">
                          <span class="label d-flex align-items-center gap-4-0 paragraph-xs-small paragraph-xs-small-768 text-red-700 font-open gap-4-768 font-semibold">
                            <span><img src="/assets/images/timer-outline-red.svg" alt="clock-red"></span><span>{{remainingTime}} left</span>
                          </span>
                        </div>
                      }
                    </div>
                  </ng-container>
                </ng-container>
                  </button>
                }
              </section>
            </drag-scroll>
            @if (scrollableCards.length > 1) {
              <div class="card-nav d-flex align-items-center justify-content-between w-100 mb-12">
                <button
                  class="card-nav-item nav-prev d-flex align-items-center justify-content-center round-4-768 shadow-small"
                  (click)="moveLeft()"
                  [disabled]="leftBoundReached"
                  aria-label="Scroll cards left"
                  >
                  <img src="/assets/images/chevron-left-arrow-gray.svg" alt="chevron-left" />
                </button>
                <button
                  class="card-nav-item nav-next d-flex align-items-center justify-content-center round-4-768 shadow-small"
                  (click)="moveRight()"
                  [disabled]="rightBoundReached"
                  aria-label="Scroll cards right"
                  >
                  <img src="/assets/images/chevron-left-arrow-gray.svg" alt="chevron-right" />
                </button>
              </div>
            }
          </div>

        </div>
        <div class="dashboard-service-container d-flex flex-column gap-24-768 gap-16 px-24 padding-0-768">
          <h3 class="dashboard-service-title heading3 heading3-768 font-semibold text-black d-flex">IELTS services</h3>
          <div class="dashboard-service-card-wrapper d-flex gap-24-768 gap-16">
            <a class="dashboard-service-card p-24-768 p-20 d-flex flex-column gap-24-768 gap-16 border-rgbagrey500-768 round-8 round-8-768 background-white shadow-small"
              (click)="navigateToMyTest()">
              <div class="d-flex justify-content-between">
                <img src="assets/images/dashboard-calendar.svg" alt="dashboard-calendar" class="dashboard-service-icon" />
                <img src="assets/images/dashboard-back-arrow.svg" alt="dashboard-back-arrow" class="mobile-back">
              </div>
              <div class="content d-flex flex-column gap-4-0 gap-4-768">
                <h3 class="heading3-768 heading4 text-black">My tests and results</h3>
                <p class="paragraph-Medium paragraph-Medium-768 txt-charcoalGrey500 font-open">Access your IELTS
                  test results and manage
                your upcoming test bookings.</p>
              </div>
              <div class="dashboard-service-arrow border-rgbagrey500-768 p-12 round-4-768 d-md-flex">
                <span class="dashboard-service-arrow-icon"></span>
              </div>
            </a>
            <a class="dashboard-service-card p-24-768 p-20 d-flex flex-column gap-24-768 gap-16 border-rgbagrey500-768 round-8 round-8-768 background-white shadow-small"
              (click)="navigateToPrep()" (keyup)="navigateToPrep()">
              <div class="d-flex justify-content-between">
                <img src="assets/images/dashboard-books.svg" alt="books-icon" class="dashboard-service-icon">
                <img src="assets/images/dashboard-back-arrow.svg" alt="dashboard-back-arrow" class="mobile-back">
              </div>
              <div class="content d-flex flex-column gap-4-0 gap-4-768">
                <h3 class="heading3-768 heading4 text-black">My IELTS preparation</h3>
                <p class="paragraph-Medium paragraph-Medium-768 txt-charcoalGrey500 font-open">Get ready for IELTS
                  and prepare with these
                free resources.</p>
              </div>
              <div class="dashboard-service-arrow border-rgbagrey500-768 p-12 round-4-768 d-md-flex">
                <span class="dashboard-service-arrow-icon"></span>
              </div>
            </a>
            <a class="dashboard-service-card p-24-768 p-20 d-flex flex-column gap-24-768 gap-16 border-rgbagrey500-768 round-8 round-8-768 background-white shadow-small"
              (click)="navigateToCommunity()" (keyup)="navigateToCommunity()">
              <div class="d-flex justify-content-between">
                <img src="assets/images/community-icon.svg" alt="books-icon" class="dashboard-service-icon">
                <img src="assets/images/dashboard-back-arrow.svg" alt="dashboard-back-arrow" class="mobile-back">
              </div>
              <div class="content d-flex flex-column gap-4-0 gap-4-768">
                <h3 class="heading3-768 heading4 text-black">My IELTS community</h3>
                <p class="paragraph-Medium paragraph-Medium-768 txt-charcoalGrey500 font-open">Join the IELTS community and connect with IELTS experts and test takers.</p>
              </div>
              <div class="dashboard-service-arrow border-rgbagrey500-768 p-12 round-4-768 d-md-flex">
                <span class="dashboard-service-arrow-icon"></span>
              </div>
            </a>
          </div>
        </div>

        @if (essentialsData?.title) {
          <div class="info-pod position-relative overflow-hidden px-24 py-32 px-56-768 py-48-768 round-16 round-24-768 align-items-start">
            @if (!isMobileView) {
              <img src="assets/24_icons/decored-top-corner.svg" alt="decored-top-corner" class="corner-shape position-absolute top-right">
            }
            @if (isMobileView) {
              <img src="assets/24_icons/decored-top-corner-mob.svg" alt="decored-top-corner" class="corner-shape position-absolute top-right">
            }
            @if (!isMobileView) {
              <img src="assets/24_icons/decored-bottom-corner.svg" alt="decored-bottom-corner" class="corner-shape position-absolute bottom-left">
            }
            @if (isMobileView) {
              <img src="assets/24_icons/decored-bottom-corner-mob.svg" alt="decored-bottom-corner" class="corner-shape position-absolute bottom-left">
            }
            <div class="d-flex flex-column gap-20 gap-40-768">
              <div class="info-header d-flex flex-column gap-6 gap-12-768">
                <h3 class="info-header-title txt-black heading2 heading2-768">{{essentialsData?.title}}</h3>
                <div class="d-flex gap-44-768 gap-16 flex-wrap-sm">
                  <p class="info-short-description paragraph-small paragraph-Medium-768 txt-charcoalGrey500 font-open">
                    {{essentialsData?.shortDescription}}
                  </p>
                  <button class="explore-btn round-100 d-flex py-8 px-20 py-12-768 px-28-768 paragraph-extra-Medium-768 paragraph-extra-Medium font-semibold d-md-flex justify-content-center align-items-center txt-charcoalGrey500 text-trim no-wrap pointer" (click)="goToExploreEssentials(essentialsData?.internalName)">
                    {{essentialsData?.internalName}}
                  </button>
                </div>
              </div>
              <div class="menu d-flex flex-column-sm gap-8-768 gap-8 justify-content-between">
                @for (item of essentialsItems; track item) {
                  <div class="menu-item w-100 d-flex gap-12 gap-16-768 round-12 round-12-768 p-12 px-12-768 py-12-768 font-bold align-items-center justify-content-between pointer" [class.active]="item.title === activeEssentials" (click)="navigateToEssentials(item)">
                    <div class="d-flex gap-12 gap-12-768">
                      <img [src]="item?.image?.media?.description" class="essentials-icon" alt="money transfer icon">
                      <span class="d-flex w-100 label heading4-768 heading4 txt-charcoalGrey500 align-items-center no-wrap">{{item?.title}}</span>
                    </div>
                    <img src="/assets/images/chevron-right-gray.svg" class="arrow-icon" alt="arrow-right">
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
  <div class="popup-overlay popup-backgound" [class.active]="popup">
  </div>
  <section class="dashboardpopup flex-column gap-15 gap-md-0" [class.active]="popup">
    <div
      class="dashboardpopup__header d-flex justify-content-end justify-content-md-between align-items-center px-15 gap-16 p-24-768 pl-32-768 gap-16-768 border-bottom-rgbaGrey500-768 ">
      <h2 class="d-none d-md-flex heading3-768 txt-black font-semibold">I've completed my payment, what's next?</h2>
      <button class="d-none d-md-flex" (click)="popUpOpenorClose()" (keyup)="popUpOpenorClose()"><img src="/assets/images/close.svg"
      alt="close"></button>
      <button class="d-flex d-md-none" (click)="popUpOpenorClose()" (keyup)="popUpOpenorClose()"><img src=" /assets/images/close-white.svg"
      alt="close"></button>
    </div>
    <div class="dashboardpopup__wrapper background-white py-24 px-8 px-8-768 py-32-768 round-16 round-0-768">
      <div
        class="dashboardpopup__body d-flex flex-column align-items-md-center px-24 gap-32 px-24-768 gap-32-768 background-white">
        <img src="/assets/images/Illustration pod.svg" alt="illustation-img">
        <div class="dashboardpopup__content d-flex flex-column gap-6 gap-6-768">
          <h3 class="heading2  heading2-768 text-black font-bold txt-bold">Thank you for completing your payment!</h3>
          <div class="paragraph d-flex flex-column gap-28 gap-32-768">
            <p class="font-open paragraph-Medium paragraph-large-768 txt-charcoalGrey500">Your test centre will confirm
              your
              payment within 2-3 business days. Once the funds are verified, your test booking will
            be confirmed.</p>
            <p class="font-open paragraph-Medium paragraph-large-768 txt-charcoalGrey500">In the meantime, please continue
            completing your application.</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dashboardpopup__button d-flex align-items-center justify-content-center py-20 px-24 py-20-768 px-32-768 background-white">
      <button
      class="background-red500 txt-white p-12 round-100 p-12-768  lh-24-0 font-semibold paragraph-Medium paragraph-Medium-768 lh-24-768  round-100-768 d-flex align-items-center justify-content-center" (click)="popUpOpenorClose()">Got it</button>
    </div>
  </section>
  @if (openOverlayBlock) {
    <app-offline-overlay [offlinePageData]="offlinePageData" [receiptNumber]="receiptNumber"></app-offline-overlay>
  }

@if (showBiometricConsentOverlay) {
  <app-biometric-consent-overlay (closeOverlay)="closeBiometricConsentOverlay()" (confirmConsent)="confirmBiometricConsent()"></app-biometric-consent-overlay>
}
